import { groq } from 'next-sanity'
import { flexibleContent, seoFields } from '@otomoro/sanity/lib/queries/partials/shared'

export const technologyPageQuery = groq`*[_type == "technologyPage" && language == "en"][0] {
  pageTitle,
  headline,
  subHeadline,
  map,
	${flexibleContent}
  ${seoFields}
}`

export const technologyPageSeoQuery = groq`*[_type == "technologyPage" && language == "en"][0]{
  ${seoFields}
}`
